import React from 'react';
import { Box, Image, HStack, Button,Text } from '@chakra-ui/react';
import '../Common/font/stylesheet.css'

const Header = () => {
  return (
    <Box
      bg="#fff"
      w="full"
      h={['100%', '100%', '100%', '80vh']}
      display="flex"
      flexDirection={['column', 'row']}
      justifyContent="center"
      alignItems="center"
      gap={[6, 0]}
      mt={['1rem','0']}
      p={['1rem', '1.5rem', '2rem', '4rem']}
    >
      <Box
        w={['100%','50%','50%', '50%']}
        float="left"

        mr={['none', 'none', 'none', '2rem']}
      >
        <Text
          fontSize={['32px', '1.5rem', '2rem', '4rem']}
          color="#1F1F29"
        fontFamily='Duplicate Sans'
          lineHeight={['42px', '42px', '42px', '72px']}
          fontWeight="500"
        >
          Go Cardless with NeemblePay
        </Text>
        <Text
          fontSize={['12.5px', '1rem']}
          lineHeight={['24px',"28px"]}
          noOfLines={['3',]}
          mt="1rem"
          color="#1F1F29"
          fontFamily='Work Sans'
        >
          Enjoy seamless and easy access to your funds with cardless 
          withdrawal and biometric online payment.
        </Text>
        <HStack mt="1rem" fontFamily='Work Sans' gap={['4', '2', '2', '2']}>
          <Button
            href="#services"
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontSize={['.7rem', '1rem', '.7rem', '1rem']}
            color="#fff"
            bg="#246BFD"
            p={['.75rem 1.5rem', ' 16px, 24px, 16px, 24px', ' 16px, 24px, 16px, 24px',' 20px, 24px, 20px, 24px']}
            w={['130px','160px','160px','206px']} h={['44px','50px','50px','64px']}
            borderRadius="16px"
            fontWeight="500"
            fontFamily='Work Sans'
            _active={{ color: '#000' }}
          >
            Get Neemblepay&nbsp;{' '}
            <Image
              src="/hero_arrow.png"
              _hover={{ marginLeft: '.2rem' }}
              alt="socials"
            />
          </Button>
          <Button
            display={['flex','flex','flex', 'flex']}
            href="#services"
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontSize={['.7rem', '.7rem', '.7rem', '1rem']}
            color="#000"
            bg="#fff"
            fontFamily='Work Sans'
            p=".15rem 1rem"
            borderRadius="16px"
            fontWeight="500"
            _active={{ color: '#000' }}
          >
            <Image src="/play.svg" alt="socials" />
            &nbsp;See a demo
          </Button>
        </HStack>
      </Box>
      <Box w={['100%','50%','50%', '50%']} display={['none','block']} >
        <Image m="auto" w="" h="100%" src="/mobile.png" display={['none','block']} alt="mobile" />
      </Box>
    </Box>
  );
};

export default Header;
